import axios from './HTTP'

export default {
  getAll (callback) {
    axios
      .get('/api/referrers.json')
      .then(response => ( callback(response.data) ))
  },

  create (referrer, callback, errorCallback) {
    axios
      .post('/api/referrers.json', {
        referrer: {
          name: referrer.name
        }
      })
      .then(response => ( callback(response.data) ))
      .catch(err => ( errorCallback(err) ))
  },

}
